import { render, staticRenderFns } from "./ServiceRecords.vue?vue&type=template&id=b56a9eaa&"
import script from "./ServiceRecords.vue?vue&type=script&lang=js&"
export * from "./ServiceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports